import React from 'react';

import {GuestPicker} from '@homeaway/react-guest-picker';

import {useComponent} from './hooks';

import './SearchGuestsInputField.less';

function SearchGuestsInputField() {
    const {
        className,
        actionLocation,
        adultsCount,
        adultsLabel,
        adultsMax,
        adultsMin,
        applyButtonLabel,
        centered,
        childrenCount,
        childrenLabel,
        childrenMax,
        childrenMin,
        clearButtonLabel,
        continueButtonLabel,
        disableButton,
        disableTextInput,
        fadeOut,
        fadeOutDuration,
        formSuffixElement,
        guestLabel,
        id,
        inputIcon,
        isMobile,
        isOpen,
        label,
        modalTitle,
        name,
        onChange,
        onClear,
        onClose,
        onExit,
        onOpen,
        petIncluded,
        petLabel,
        petNoLabel,
        petYesLabel,
        placement,
        positionIconRight,
        readOnly,
        showClearButton,
        showContinue,
        showPetOption,
        wdioPrefix
    } = useComponent();

    return (
        <div className={className}>
            <GuestPicker
                actionLocation={actionLocation}
                adultsCount={adultsCount}
                adultsLabel={adultsLabel}
                adultsMax={adultsMax}
                adultsMin={adultsMin}
                applyButtonLabel={applyButtonLabel}
                centered={centered}
                childrenCount={childrenCount}
                childrenLabel={childrenLabel}
                childrenMax={childrenMax}
                childrenMin={childrenMin}
                clearButtonLabel={clearButtonLabel}
                continueButtonLabel={continueButtonLabel}
                disableButton={disableButton}
                disableTextInput={disableTextInput}
                fadeOut={fadeOut}
                fadeOutDuration={fadeOutDuration}
                formSuffixElement={formSuffixElement}
                guestLabel={guestLabel}
                id={id}
                inputIcon={inputIcon}
                isMobile={isMobile}
                isOpen={isOpen}
                label={label}
                modalTitle={modalTitle}
                name={name}
                onChange={onChange}
                onClear={onClear}
                onClose={onClose}
                onExit={onExit}
                onOpen={onOpen}
                petIncluded={petIncluded}
                petLabel={petLabel}
                petNoLabel={petNoLabel}
                petYesLabel={petYesLabel}
                placement={placement}
                positionIconRight={positionIconRight}
                readOnly={readOnly}
                showClearButton={showClearButton}
                showContinue={showContinue}
                showPetOption={showPetOption}
                wdioPrefix={wdioPrefix}
            />
        </div>
    );
}

export {SearchGuestsInputField};
